
import { defineComponent } from 'vue';
import { estateAgentReviewService } from '../EstateAgentReviewService';
import EstateAgentReviewRatingGraph from './EstateAgentReviewRatingGraph.vue';
import EstateAgentReviewStarsListItem from './EstateAgentReviewStarsListItem.vue';

export default defineComponent({
  components: {
    EstateAgentReviewRatingGraph,
    EstateAgentReviewStarsListItem,
  },
  props: {
    frontUserId: { type: Number, required: true },
  },
  data() {
    return {
      data: {},
    };
  },
  async created() {
    if (this.frontUserId) {
      await this.loadData();
    }
  },
  methods: {
    async loadData() {
      try {
        this.data = (await estateAgentReviewService.getByEstateAgent(this.frontUserId)).data;
      } catch (error) {
        console.error(error);
      }
    },
  },
});
